import { useEffect } from 'react';
import { Clock3 } from 'lucide-react';

export function LegacyRateQuoteUnavailable() {
  useEffect(() => {
    document.title = 'Rate quote unavailable | Lendwise Mortgage';

    let robots = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement('meta');
      robots.name = 'robots';
      document.head.appendChild(robots);
    }
    robots.content = 'noindex, nofollow, noarchive';
  }, []);

  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-50 px-5 py-12 text-slate-950">
      <section className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-7 text-center shadow-sm sm:p-10">
        <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-amber-50 text-amber-700">
          <Clock3 aria-hidden="true" className="size-6" />
        </div>
        <p className="mt-5 text-xs font-semibold uppercase tracking-[0.18em] text-emerald-800">
          Lendwise Mortgage
        </p>
        <h1 className="mt-2 text-2xl font-semibold tracking-tight">This rate quote is no longer available</h1>
        <p className="mt-3 text-sm leading-6 text-slate-600">
          This historical quote has expired. Please contact your loan officer for current rates and loan options.
        </p>
        <p className="mt-5 text-xs leading-5 text-slate-500">
          Mortgage rates and terms can change. A new quote is required before relying on any prior pricing.
        </p>
      </section>
    </main>
  );
}
